import { createAction } from 'redux-actions';

import { SET_TITLE, SET_SUBTITLE } from './actionTypes';

export const setTitle = createAction<string>(SET_TITLE);
export const setSubtitle = createAction<string>(SET_SUBTITLE);
